import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const Tabs = ({
  uniqueId,
  children,
  selectedIndex,
  onSelect,
  skipPanelRendering,
  noMargin,
  compact
}) => React.createElement("div", {
  className: classnames('tabs', {
    'tabs--no-margin': noMargin,
    'tabs--compact': compact
  })
}, React.createElement(Tabs.TabList, {
  selectedIndex: selectedIndex,
  uniqueId: uniqueId,
  onSelect: onSelect
}, children), !skipPanelRendering && React.createElement(Tabs.TabPanels, {
  selectedIndex: selectedIndex,
  uniqueId: uniqueId
}, children));

Tabs.TabList = ({
  children,
  selectedIndex,
  uniqueId,
  onSelect
}) => React.createElement("ul", {
  className: "tabs__list",
  role: "tablist"
}, children.map((element, index) => React.createElement(Tabs.Tab, {
  key: index,
  index: index,
  selectedIndex: selectedIndex,
  uniqueId: uniqueId,
  heading: element.props.heading,
  onSelect: onSelect
})));

Tabs.Tab = ({
  index,
  uniqueId,
  selectedIndex,
  heading,
  onSelect
}) => React.createElement("li", {
  className: classnames('tabs__list-item', {
    'tabs__list-item--selected': selectedIndex === index
  }),
  id: `${uniqueId}-tab-${index}`,
  role: "tab",
  "aria-controls": `${uniqueId}-panel-${index}`,
  "aria-selected": selectedIndex === index
}, React.createElement("button", {
  onClick: () => onSelect(index),
  className: "link tabs__button"
}, heading));

Tabs.TabPanels = ({
  children,
  uniqueId,
  selectedIndex
}) => children.map((element, index) => React.cloneElement(element, {
  key: index,
  index,
  uniqueId,
  isSelected: index === selectedIndex
}));

Tabs.TabPanel = ({
  index,
  uniqueId,
  isSelected,
  children
}) => React.createElement("div", {
  className: classnames('tabs__content', {
    'tabs__content--selected': isSelected
  }),
  id: `${uniqueId}-panel-${index}`,
  "aria-labelledby": `${uniqueId}-tab-${index}`,
  role: "tabpanel"
}, children);

Tabs.propTypes = process.env.NODE_ENV !== "production" ? {
  uniqueId: PropTypes.string,
  selectedIndex: PropTypes.number,
  onSelect: PropTypes.func
} : {};
Tabs.defaultProps = {
  selectedIndex: 0
};
export default Tabs;